import React, { useEffect, useRef } from "react";
import "./Packages.css";
import { gsap } from "gsap";
import package1img1 from "../../Asset/package1img.jpeg";
import package1img2 from "../../Asset/package1img2.jpeg";
import package2img1 from "../../Asset/package2img1.jpeg";
import package2img2 from "../../Asset/package2img2.jpeg";
import spcl1 from "../../Asset/spcl1.jpeg";
import spcl2 from "../../Asset/spcl2.jpeg";
import spcl3 from "../../Asset/spcl3.jpeg";
import spcl4 from "../../Asset/spcl4.jpeg";
import gallery1 from "../../Asset/gallery1.jpeg";
import gallery2 from "../../Asset/gallery2.jpeg";
import gallery3 from "../../Asset/gallery3.jpeg";
import gallery4 from "../../Asset/gallery4.jpeg";
import gallery5 from "../../Asset/gallery5.jpeg";
import gallery6 from "../../Asset/gallery6.jpeg";
import gallery7 from "../../Asset/gallery7.jpeg";
import { ChevronDoubleRightIcon } from "@heroicons/react/24/solid";
import { ScrollTrigger } from "gsap/ScrollTrigger";
const Packages = () => {
  const triggerRef = useRef(null);
  const sectionRef = useRef(null);
  gsap.registerPlugin(ScrollTrigger);
  let t1 = gsap.timeline({ paused: true, reversed: true });
  var scrollData = "";
  var scrollDataSign1 = "";
  var scrollDataSign2 = "";
  var scrollDataspeed = "";
  function getScrollData() {
    console.log(scrollData);
    if (window.innerWidth >= 1200) {
      scrollData = "3%";
      scrollDataSign1 = "-6deg";
      scrollDataSign2 = "6deg";
      scrollDataspeed = "-45vw";
    } else if (window.innerWidth >= 600) {
      scrollData = "87%";
      scrollDataSign1 = "6deg";
      scrollDataSign2 = "-6deg";
      scrollDataspeed = "-95vw";
    } else {
      scrollData = "97%";
      scrollDataSign1 = "6deg";
      scrollDataSign2 = "-6deg";
      scrollDataspeed = "-105vw";
    }
  }
  useEffect(() => {
    getScrollData();
  }, [window.innerWidth]);
  useEffect(() => {
    t1.play();

    t1.to(".package1img1", {
      left: scrollData,
      rotate: scrollDataSign1,
      scrollTrigger: {
        trigger: ".PackagePlace",
        scrub: 3,
      },
    });
    t1.to(".package1img2", {
      right: scrollData,
      rotate: scrollDataSign2,
      scrollTrigger: {
        trigger: ".PackagePlace",
        scrub: 3,
      },
    });

    // package2

    t1.to(".package2img1", {
      left: scrollData,
      rotate: scrollDataSign1,
      scrollTrigger: {
        trigger: ".PackagePlace2",
        scrub: 3,
      },
    });
    t1.to(".package2img2", {
      right: scrollData,
      rotate: scrollDataSign2,
      scrollTrigger: {
        trigger: ".PackagePlace2",
        scrub: 3,
      },
    });

    //
    t1.to(".spclImgContainer", {
      scale: 1.2,
      scrollTrigger: {
        trigger: ".spclImgContainer",
        scrub: 2,
      },
    });
  }, []);
  useEffect(() => {
    const pin = gsap.fromTo(
      sectionRef.current,
      {
        translateX: 0,
      },
      {
        translateX: scrollDataspeed,
        ease: "none",
        scrollTrigger: {
          trigger: triggerRef.current,
          start: "top 50%",
          scrub: 3,
        },
      }
    );

    return () => {
      pin.kill();
    };
  }, []);
  return (
    <div className="PackagesContainer">
      <div className="Package">
        <div className="PackageDetails">
          <div className="PackageDetailsHeading">
            <h5>March 2023</h5>
            <ChevronDoubleRightIcon className="PackageDetailsHeadIcon" />
            <h5>GREENLAND</h5>
          </div>
          <h1 className="PackagePlace">
            Visit <br /> Greenland
          </h1>
          <button className="PackageAction">Explore</button>
        </div>
        <img className="package1img1" src={package1img1} alt="" />
        <img className="package1img2" src={package1img2} alt="" />
      </div>
      <div className="Package">
        <div className="PackageDetails">
          <div className="PackageDetailsHeading">
            <h5>SEPTEMBER 2019</h5>
            <ChevronDoubleRightIcon className="PackageDetailsHeadIcon" />
            <h5>MONGOLIA</h5>
          </div>
          <h1 className="PackagePlace2">
            Visit <br /> MONGOLIA
          </h1>
          <button className="PackageAction">Explore</button>
        </div>
        <img className="package2img1" src={package2img1} alt="" />
        <img className="package2img2" src={package2img2} alt="" />
      </div>
      <div ref={triggerRef} className="GalleryWrapper">
        <div ref={sectionRef} className="ourGallery">
          <img className="gallery1" src={gallery1} alt="" />
          <img className="gallery2" src={gallery2} alt="" />
          <img className="gallery3" src={gallery3} alt="" />
          <img className="gallery4" src={gallery4} alt="" />
          <img className="gallery5" src={gallery5} alt="" />
          <img className="gallery6" src={gallery6} alt="" />
          <img className="gallery7" src={gallery7} alt="" />
          <img className="gallery1" src={gallery1} alt="" />
          <img className="gallery2" src={gallery2} alt="" />
          <img className="gallery3" src={gallery3} alt="" />
          <img className="gallery4" src={gallery4} alt="" />
          <img className="gallery5" src={gallery5} alt="" />
          <img className="gallery6" src={gallery6} alt="" />
          <img className="gallery7" src={gallery7} alt="" />
        </div>
      </div>
      <div className="Package package4">
        <div className="PackageDetails">
          <div className="PackageDetailsHeading">
            <h5>NOVEMBER 2022 </h5>
            <ChevronDoubleRightIcon className="PackageDetailsHeadIcon" />
            <h5>CORNWALL, SCOTLAND</h5>
          </div>
          <h1 className="PackagePlace3">Amelia</h1>
          <div className="spclImgContainer">
            <img className="spcl1" src={spcl1} alt="" />
            <img className="spcl2" src={spcl2} alt="" />
            <img className="spcl3" src={spcl3} alt="" />
            <img className="spcl4" src={spcl4} alt="" />
          </div>
          <button className="PackageAction3">Explore</button>
        </div>
      </div>
    </div>
  );
};

export default Packages;
